import React, { useMemo, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { withForm } from "components/common";
import { FormGroup, SaveButton, required } from "components/common/Forms";
import { compose, withState, withStateHandlers } from "recompose";
import { Alert, Row, Col, Spinner } from "reactstrap";
import { LocalForm, Control, actions, Errors } from "react-redux-form";
import { get, initial, map } from "lodash";
import { Link } from "react-router-dom";
import { isEmail } from "validator";
import { Trans, withTranslation, useTranslation } from "react-i18next";
import countryList from 'react-select-country-list';
import Select from "react-select";
import { ApiClient, } from "services";
import {
    withGoogleReCaptcha
} from "react-google-recaptcha-v3";
import { NotificationManager } from "react-notifications";


const apiClient = ApiClient()


const passwordsMatch = ({ password, confirm_password }) => {
    if (!(password && confirm_password)) return false;
    return password === confirm_password;
};

const emailsMatch = ({ email, confirm_email }) => {
    if (!(email && confirm_email)) return false;
    return email === confirm_email;
};

const getLanguageList = () => {
    return apiClient.get('core/hesaab_language').then((res) => res.data)
}

const HelpText = ({ children }) => (
    <span className="form-text small text-danger">
        <Trans>{children}</Trans>
    </span>
);

const ErrorText = ({ children }) => (
    <li className='text-danger'>
        <p className="display-8 m-0"><Trans>{children}</Trans></p>
    </li>
);

export const Register = ({
    item,
    form,
    setDispatch,
    onSubmit,
    onUpdate,
    onChange,
    dispatch,
    success,
    setFirstNameRef,
    t,
    setRegister,
    app,
    tokeInfo,
    client,
}) => {

    const { i18n } = useTranslation();

    const countryOptions = useMemo(() => countryList().getData(), [])
    const [languageOptions, setLanguageOptions] = useState([])

    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const selected_plan = searchParams.get('selected_plan');
    const [initialState, setInitialState] = useState(null)

    const default_lang = useMemo(() => { return languageOptions.find(item => item.label === "Arabic")?.value }, [languageOptions])

    useEffect(async () => {
        const response = await getLanguageList()
        setLanguageOptions(response.map(item => ({ value: item.id, label: t(item.name) })))
    }, [t]);

    const ValidationList = ({ password }) => {
        if (!password) return null
        const criteria = [
            {
                label: "Password must be at least 8 characters long.",
                test: (pwd) => pwd.length >= 8,
            },
            {
                label: "Password must contain at least one digit.",
                test: (pwd) => /[0-9]/.test(pwd),
            },
        ];
        return (
            <ul className="styled pl-3 mb-0">
                {criteria.map((criterion, idx) => (
                    <li key={idx} className={criterion.test(password) ? 'text-left text-success' : 'text-left text-danger'}>
                        <p className="display-8 m-0">{t(criterion.label)}</p>
                    </li>
                ))}
            </ul>
        );
    };

    useEffect(() => {
        if (tokeInfo) {
            client.post(`apps/0/${app}/connection/get_store_details`, tokeInfo).get('data').then((resp) => {
                setInitialState(resp)
            }).catch((err) => {
                console.log(t('error fetching store info'), err)
            })
        }
    }, []);

    if (!initialState) {
        return (
            <div className="">
                <span className="fa fa-fw fa-spin fa-spinner mr-1" /><Trans>Loading Store Details...</Trans>
            </div>
        )
    }

    return (
        <div className={`col-sm`}>
            <div id="contact-form-1" className="register">
                <p className="log-text">
                    <Trans>Complete the form below to create an account.</Trans>
                </p>
                <LocalForm
                    initialState={initialState}
                    onSubmit={onSubmit}
                    getDispatch={setDispatch}
                    onUpdate={onUpdate}
                    onChange={onChange}
                    className="contactForm"
                    validators={{
                        "": { passwordsMatch, emailsMatch, },
                        first_name: { required },
                        last_name: { required },
                        email: { isEmail },
                        password: { required },
                        // contact_number: { required },
                        company_name: { required },
                        country: { required },
                        language: { required },
                    }}
                >
                    <Row noGutters>
                        <Col xs={false} lg={6}>
                            <Control.input
                                model=".referral_code"
                                type="hidden"
                                defaultValue={localStorage.getItem('referral_code') || ''}
                            />
                            <Control.input
                                model=".temp_subscription_plan"
                                type="hidden"
                                defaultValue={selected_plan}
                            />
                            <FormGroup style={{ marginBottom: "1rem" }} className="pr-lg-3" model=".first_name">
                                <Control.text
                                    model=".first_name"
                                    getRef={setFirstNameRef}
                                    className="rounded"
                                    id="first_name"
                                    placeholder={t("First Name")}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={false} lg={6}>
                            <FormGroup style={{ marginBottom: "1rem" }} model=".last_name">
                                <Control.text
                                    model=".last_name"
                                    className="rounded"
                                    placeholder={t("Last Name")}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row noGutters>
                        <Col xs={false} lg={6}>
                            <FormGroup style={{ marginBottom: "1rem" }} className="pr-lg-3" model=".company_name">
                                <Control.text
                                    model=".company_name"
                                    className="rounded"
                                    placeholder={t("Company Name")}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={false} lg={6}>
                            <FormGroup style={{ marginBottom: "1rem" }} model=".contact_number">
                                <Control.text
                                    model=".contact_number"
                                    className="rounded"
                                    placeholder={t("Contact Number")}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <FormGroup style={{ marginBottom: "1rem" }} model=".tax_number" hidden>
                        <Control.text
                            model=".tax_number"
                            className="rounded"
                            placeholder={t("Tax Number")}
                        />
                    </FormGroup>
                    <Row>
                        <Col xs={false} lg={6}>
                            <FormGroup label={t("Country *")} model=".country" addControlClass={false} className="my-1 text-left" >
                                <Control.text
                                    model=".country"
                                    component={Select}
                                    options={countryOptions}
                                    defaultValue={'SA'}
                                    simpleValue
                                    clearable={false}
                                    searchable={true}
                                    placeholder={t('Select...')}
                                    style={{ backgroundColor: '#F4F7FE' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={false} lg={6} className="pl-0">
                            <FormGroup label={t("Base Language *")} model=".language" addControlClass={false} className="my-1 text-left">
                                <Control.text
                                    model=".language"
                                    component={Select}
                                    options={languageOptions}
                                    defaultValue={default_lang}
                                    simpleValue
                                    clearable={false}
                                    searchable={true}
                                    placeholder={t('Select...')}
                                    style={{ backgroundColor: '#F4F7FE' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row noGutters className="mt-3">
                        <Col xs={false} lg={6}>
                            <FormGroup style={{ marginBottom: "1rem" }} className="pr-lg-3">
                                <Control.text
                                    model=".email"
                                    className="rounded"
                                    placeholder={t("Email")}
                                />
                                <Errors
                                    model="serverErrors.email"
                                    component={() => (
                                        <HelpText>
                                            <Trans>A user with this email address already exists</Trans>
                                        </HelpText>
                                    )}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={false} lg={6}>
                            <FormGroup style={{ marginBottom: "1rem" }}>
                                <Control.text
                                    model=".confirm_email"
                                    className="form-control rounded"
                                    placeholder={t("Confirm Email")}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row noGutters>
                        <Col xs={false} lg={6}>
                            <FormGroup className="pr-lg-3" style={{ marginBottom: "1rem" }}>
                                <Control.text
                                    changeAction={(model, value) => {
                                        dispatch(actions.change(model, value));
                                        dispatch(actions.validate(model));
                                    }}
                                    type="password"
                                    model=".password"
                                    className="rounded mb-0"
                                    placeholder={t("Password")}
                                    autoComplete="new-password"
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={false} lg={6}>
                            <FormGroup style={{ marginBottom: "1rem" }}>
                                <Control.text
                                    type="password"
                                    model=".confirm_password"
                                    className="rounded mb-0"
                                    placeholder={t("Confirm Password")}
                                    autoComplete="new-password"
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <Col xs={false} lg={12}>
                        <ValidationList password={item?.password} />
                    </Col>
                    <ul className="validation-errors styled pl-3 text-left">
                        {item?.email &&
                            <Errors
                                model="local"
                                messages={{ emailsMatch: "Emails do not match" }}
                                component={ErrorText}
                            />
                        }
                        <Errors model="serverErrors.password" component={ErrorText} />
                        {item?.password &&
                            <Errors
                                model="local"
                                messages={{ passwordsMatch: "Passwords do not match" }}
                                component={ErrorText}
                            />
                        }
                        <Errors
                            model="local"
                            messages={{
                                atLeastOneOption:
                                    "At least 1 subscription option must be selected",
                            }}
                            component={ErrorText}
                        />
                    </ul>
                    <Col xs={false} lg={6}>
                        <FormGroup  >
                            <Control.text
                                type="hidden"
                                model=".lang"
                                className="rounded mb-0"
                                defaultValue={i18n.language}
                            />
                        </FormGroup>
                    </Col>
                    <SaveButton
                        type="submit"
                        className="btn-primary-filled btn-rounded btn-form-submit btn-rounded w-100"
                        form={form}>
                        Submit
                    </SaveButton><br />
                    <Link className="small d-inline-block mt-2" to="" onClick={(e) => { e.preventDefault(); setRegister(false) }}>
                        <Trans>Already using Hesaab?</Trans> <span style={{ color: "#72B566" }}> <Trans>Sign In</Trans></span>
                    </Link>
                </LocalForm>
            </div>
        </div>
    )
};

const enhance = compose(
    withGoogleReCaptcha,
    withTranslation(),
    withState("success", "setSuccess", null),
    withState("failure", "setFailure", null),
    withForm({
        onSubmit:
            ({ client, item, setSuccess, setFailure, dispatch, location, googleReCaptchaProps, history }) =>
                async () => {
                    setSuccess(false);
                    dispatch(actions.resetErrors("serverErrors"));
                    localStorage.removeItem("hesaab/organisationId");
                    return client
                        .post("/register?auto_active=true", {
                            ...item,
                        })
                        .then(() => {
                            NotificationManager.success("Registered Successfully");
                            client.post("/auth", {
                                email: item.email.toLowerCase(),
                                password: item.password,
                            }).then((resp) => {
                                window.location.reload();
                            });
                        })
                        .catch((err) => {
                            const code = get(err, "response.data.code");

                            if (code === "invalid") {
                                map(err.response.data, (v, k) =>
                                    dispatch(actions.setErrors(`serverErrors["${k}"]`, v))
                                );
                            } else {
                                throw err;
                            }
                        });
                },
    }),
    withStateHandlers(
        {},
        {
            setFirstNameRef: () => (firstNameRef) => ({ firstNameRef }),
        }
    )
);

export default enhance(Register);